import { useQuery } from "@tanstack/react-query";
import { fetchAllCountries } from "services/country";

export const useAllCountries = (enabled = true) =>
  useQuery({
    queryKey: ["countries"],
    queryFn: fetchAllCountries,
    staleTime: Infinity,
    enabled,
  });
